import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import PackageTabs from "../AllTabs/PackageTabs";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import "../Package/Package.css";

// --- Components ---
import HolidayForm from "./HolidayForm"; 
import HolidayItinerary from "./HolidayItinerary";     
import HolidayFlightBooking from "./HolidayFlightBooking";
import HolidayHotelBooking from "./HolidayHotelBooking";
import HolidaySightseeing from "./HolidaySightseeing"; 
import HolidayTransfer from "./HolidayTransfer";       
import HolidayInclude from "./HolidayInclude";         
import HolidayExclude from "./HolidayExclude";         // Uncomment when created
 import HolidayTermsandCondition from "./HolidayTermsandCondition"; // Uncomment when created


import HolidayTemplates from "./HolidayTemplates";
// import PackageManageApplicants from "./PackageManageApplicants";

import {
  RiListCheck, RiPlaneLine, RiHotelBedLine, RiCameraLensLine, RiCarLine,
  RiMapPinLine, RiCheckboxCircleLine, RiCloseCircleLine, RiFileShieldLine,
  RiEyeLine, RiLayoutLine, RiGroupLine
} from "react-icons/ri";
import HolidayDetailsView from "./HolidayDetailsView";

const HolidayComponent = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { packageId } = useParams(); 

  const [isCreated, setIsCreated] = useState(!!packageId);
  const [isEditMode, setIsEditMode] = useState(!!packageId);
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || 0);
  const [packageDetails, setPackageDetails] = useState(null);

  // Handle Edit Mode Logic
  useEffect(() => {
    if (packageId) {
      setIsCreated(true);
      setIsEditMode(true);
      if (location.state?.activeTab !== undefined) {
        setActiveTab(location.state.activeTab);
      }
    } else {
      setIsCreated(false);
      setIsEditMode(false);
      setActiveTab(0);
      setPackageDetails(null);
    }
  }, [packageId, location.state]);

  // Fetch Holiday Data
  const getHolidayDetails = useCallback(async () => {
    if (packageId) {
      try {
        const response = await apiService.get(`${config.GETHOLIDAYBYID}/${packageId}`);
        console.log("Holiday Details:", response);
        setPackageDetails(response.data || response);
      } catch (error) {
        console.error("Failed to fetch holiday details:", error);
      }
    }
  }, [packageId]);

  useEffect(() => {
    getHolidayDetails();
  }, [getHolidayDetails]);

  // Callback for children to trigger refresh after update
  const handleHolidayUpdate = () => {
    getHolidayDetails();
  };

  const handleTabSelect = (index) => {
    setActiveTab(index);
  };

  const handleHolidayCreated = (newHolidayId) => {
    navigate(`/holiday/edit/${newHolidayId}`, { state: { activeTab: 1 } });
  };

  useEffect(() => {
    if (!loading && !user) {
      navigate("/");
    }
  }, [user, loading, navigate]);

  if (loading) return <p>Loading...</p>;

  return (
     <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card">
              <div className="p-2">
                <PackageTabs pageName="HOLIDAY PACKAGE" />
              </div>
              <div className="package-tabs-container">
                <div className="package-tabs-nav">
                  <Tabs selectedIndex={activeTab} onSelect={handleTabSelect}>
                    <TabList className="list-unstyled">
                      <Tab className={`package-tab-item ${activeTab === 0 ? "active" : ""}`}><RiListCheck /><span>Package Form</span></Tab>
                      <Tab className={`package-tab-item ${activeTab === 1 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}><RiMapPinLine /><span>Itineraries</span></Tab>
                      <Tab className={`package-tab-item ${activeTab === 2 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}><RiPlaneLine /><span>Flight</span></Tab>
                      <Tab className={`package-tab-item ${activeTab === 3 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}><RiHotelBedLine /><span>Hotel</span></Tab>
                      <Tab className={`package-tab-item ${activeTab === 4 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}><RiCameraLensLine /><span>SightSeeing</span></Tab>
                      <Tab className={`package-tab-item ${activeTab === 5 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}><RiCarLine /><span>Transfer</span></Tab>
                      <Tab className={`package-tab-item ${activeTab === 6 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}><RiCheckboxCircleLine /><span>Includes</span></Tab>
                      <Tab className={`package-tab-item ${activeTab === 7 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}><RiCloseCircleLine /><span>Excludes</span></Tab>
                      <Tab className={`package-tab-item ${activeTab === 8 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}><RiFileShieldLine /><span>Terms & Conditions</span></Tab>
                      <Tab className={`package-tab-item ${activeTab === 9 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}><RiEyeLine /><span>View Details</span></Tab>
                      <Tab className={`package-tab-item ${activeTab === 10 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}><RiLayoutLine /><span>Templates</span></Tab>
                      <Tab className={`package-tab-item ${activeTab === 11 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}><RiGroupLine /><span>Manage Applicants</span></Tab>
                    </TabList>
                  </Tabs>
                </div>

                <div className="package-tabs-content">
                  <Tabs selectedIndex={activeTab}>
                    
                    {/* TAB 0: HOLIDAY FORM */}
                    <TabPanel>
                      <HolidayForm 
                        packageId={packageId} 
                        isEditMode={isEditMode} 
                        setIsEditMode={setIsEditMode} 
                        onPackageCreated={handleHolidayCreated} 
                        packageDetails={packageDetails} 
                      />
                    </TabPanel>

                    {/* TAB 1: ITINERARY */}
                    <TabPanel>
                       <HolidayItinerary 
                         holidayId={packageId} 
                         packageDetails={packageDetails} 
                         onUpdate={handleHolidayUpdate} 
                       />
                    </TabPanel>

                    {/* TAB 2: FLIGHT */}
                    <TabPanel>
                      <HolidayFlightBooking 
                        holidayId={packageId} 
                        packageDetails={packageDetails} 
                        onUpdate={handleHolidayUpdate} 
                      />
                    </TabPanel>

                    {/* TAB 3: HOTEL */}
                    <TabPanel>
                      <HolidayHotelBooking 
                        holidayId={packageId} 
                        packageDetails={packageDetails} 
                        onUpdate={handleHolidayUpdate} 
                      />
                    </TabPanel>

                    {/* TAB 4: SIGHTSEEING */}
                    <TabPanel>
                       <HolidaySightseeing 
                         holidayId={packageId} 
                         packageDetails={packageDetails} 
                         onUpdate={handleHolidayUpdate} 
                       />
                    </TabPanel>

                    {/* TAB 5: TRANSFER */}
                     <TabPanel>
                       <HolidayTransfer 
                         holidayId={packageId} 
                         packageDetails={packageDetails} 
                         onUpdate={handleHolidayUpdate} 
                       />
                    </TabPanel>

                    {/* TAB 6: INCLUDES */}
                    <TabPanel>
                       <HolidayInclude 
                         holidayId={packageId} 
                         packageDetails={packageDetails} 
                         onUpdate={handleHolidayUpdate} 
                       />
                    </TabPanel>

                    {/* TAB 7: EXCLUDES */}
                    <TabPanel>
                       <HolidayExclude holidayId={packageId} packageDetails={packageDetails} onUpdate={handleHolidayUpdate} />
                       
                    </TabPanel>

                    {/* TAB 8: TERMS */}
                    <TabPanel>
                       <HolidayTermsandCondition holidayId={packageId} packageDetails={packageDetails} onUpdate={handleHolidayUpdate} />
                      
                    </TabPanel>

                    {/* TAB 9: VIEW DETAILS */}
                    <TabPanel>
                      <HolidayDetailsView
                        packageId={packageId} 
                        packageDetails={packageDetails} 
                        onEditRequest={handleTabSelect} 
                      />
                    
                    </TabPanel>

                    {/* TAB 10: TEMPLATES */}
                    <TabPanel>
                      <HolidayTemplates 
                        packageId={packageId} 
                        packageDetails={packageDetails} 
                      />
                     
                    </TabPanel>

                    {/* TAB 11: APPLICANTS */}
                    <TabPanel>
                      {/* <PackageManageApplicants 
                        packageId={packageId} 
                      /> */}
                      <div>Applicants Coming Soon</div>
                    </TabPanel>

                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HolidayComponent;